import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Col, Row, CardBody, Card } from 'reactstrap';
import RadioSelectTable from 'src/shared/components/table/RadioSelectTable';

const AGENCY_COLUMNS = [
  {
    key: 'employerCode',
    header: 'Agency Code',
    width: '130px',
    sortable: true,
  },
  {
    key: 'employerName',
    header: 'Agency Name',
    width: '110px',
    sortable: true,
  },
];

const DriverEmployerView = ({ reactTableData, isNoRecordFound }) => {
  const rows = reactTableData?.tableRowsData ?? [];

  const [selectedAgency, setSelectedAgency] = useState(
    rows.length > 0 ? rows[0] : null
  );

  return (
    <Col md={12} lg={12} style={{ marginTop: '20px' }}>
      <Row>
        {/* ── Left: Master List ───────────────────────────── */}
        <Col md={7} lg={7}>
          {!isNoRecordFound ? (
            <RadioSelectTable
              rows={rows}
              columns={AGENCY_COLUMNS}
              rowKey="driverEmployerId"
              selectedKey={selectedAgency?.driverEmployerId}
              onSelect={setSelectedAgency}
              searchKeys={['employerName', 'employerCode', 'contactPersonName']}
              searchPlaceholder="Search by name or code..."
              sortKey="employerName"
              headerTitle="Leased Rider Agency List"
              pageSizes={[5, 10, 20, 50]}
            />
          ) : (
            <Card style={{ borderRadius: '12px', border: '1px solid #e2e8f0', padding: '40px', textAlign: 'center' }}>
              <p className="text-muted m-0">No agencies found.</p>
            </Card>
          )}
        </Col>

        {/* ── Right: Detail Panel ─────────────────────────── */}
        <Col md={5} lg={5}>
          <Card style={{
            borderRadius: '12px',
            border: '1px solid #e2e8f0',
            boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)',
            minHeight: '520px',
            background: '#ffffff',
            overflow: 'hidden',
          }}>
            {selectedAgency ? (
              <>
                {/* Header Banner */}
                <div style={{
                  background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
                  padding: '24px 20px',
                }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <div>
                      <h4 style={{ margin: 0, fontWeight: 800, fontSize: '1.2rem', color: '#ffffff' }}>
                        {selectedAgency.employerName}
                      </h4>
                      <span style={{ fontSize: '0.85rem', color: 'rgba(255,255,255,0.85)' }}>
                        Agency Code: {selectedAgency.employerCode}
                      </span>
                    </div>
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                      <span
                        className={`badge ${selectedAgency.active === 1 || selectedAgency.active === true ? 'bg-success' : 'bg-danger'}`}
                        style={{ fontSize: '0.75rem', fontWeight: 700 }}
                      >
                        {selectedAgency.active === 1 || selectedAgency.active === true ? 'ACTIVE' : 'IN-ACTIVE'}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Details Body */}
                <CardBody style={{ padding: '20px' }}>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>

                    {/* Agency Info */}
                    <div>
                      <h6 className="text-muted text-uppercase fw-bold mb-2"
                        style={{ fontSize: '0.7rem', letterSpacing: '0.5px' }}>
                        Agency Information
                      </h6>
                      <div style={{ background: '#f8fafc', borderRadius: '8px', padding: '12px 14px', border: '1px solid #f1f5f9', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        <div className="d-flex justify-content-between">
                          <span className="text-muted small">Agency Code:</span>
                          <span className="fw-bold small text-dark">{selectedAgency.employerCode || '—'}</span>
                        </div>
                        <div className="d-flex justify-content-between">
                          <span className="text-muted small">Agency Name:</span>
                          <span className="fw-bold small text-dark">{selectedAgency.employerName || '—'}</span>
                        </div>
                      </div>
                    </div>

                    {/* Contact Details */}
                    <div>
                      <h6 className="text-muted text-uppercase fw-bold mb-2"
                        style={{ fontSize: '0.7rem', letterSpacing: '0.5px' }}>
                        Contact Person Details
                      </h6>
                      <div style={{ background: '#f8fafc', borderRadius: '8px', padding: '12px 14px', border: '1px solid #f1f5f9', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        <div className="d-flex justify-content-between">
                          <span className="text-muted small">Contact Person:</span>
                          <span className="fw-bold small text-dark">{selectedAgency.contactPersonName || '—'}</span>
                        </div>
                        <div className="d-flex justify-content-between">
                          <span className="text-muted small">Mobile No:</span>
                          <span className="fw-bold small text-dark">{selectedAgency.mobileNo || '—'}</span>
                        </div>
                        <div className="d-flex justify-content-between">
                          <span className="text-muted small">Landline No:</span>
                          <span className="fw-bold small text-dark">{selectedAgency.landLineNo || '—'}</span>
                        </div>
                      </div>
                    </div>

                    {/* Address Detail */}
                    <div>
                      <h6 className="text-muted text-uppercase fw-bold mb-2"
                        style={{ fontSize: '0.7rem', letterSpacing: '0.5px' }}>
                        Address Information
                      </h6>
                      <div style={{ background: '#f8fafc', borderRadius: '8px', padding: '12px 14px', border: '1px solid #f1f5f9' }}>
                        <span className="text-muted small d-block mb-1">Full Address:</span>
                        <span className="small fw-semibold text-dark d-block" style={{ lineHeight: '1.4', wordBreak: 'break-word' }}>
                          {selectedAgency.address || '—'}
                        </span>
                      </div>
                    </div>

                  </div>
                </CardBody>
              </>
            ) : (
              <div style={{
                display: 'flex', flexDirection: 'column', alignItems: 'center',
                justifyContent: 'center', padding: '40px', textAlign: 'center', minHeight: '520px',
              }}>
                <div style={{ fontSize: '3.5rem', color: '#cbd5e1', marginBottom: '16px' }}>🏢</div>
                <h5 className="fw-bold text-muted">No Agency Selected</h5>
                <p className="text-muted small">Select an agency from the list to view details.</p>
              </div>
            )}
          </Card>
        </Col>
      </Row>
    </Col>
  );
};

DriverEmployerView.propTypes = {
  reactTableData: PropTypes.shape({
    tableRowsData: PropTypes.arrayOf(PropTypes.shape()),
  }),
  isNoRecordFound: PropTypes.bool,
};

export default DriverEmployerView;
